import { useMemo } from "react";

import { computeAdInsertionIndices } from "src/utils/compute-ad-insertion-indices";

type MinimalBlock = {
  __typename?: string;
  placement?: string;
};

interface Options {
  paragraphRunLength: number;
}

/**
 * Derived indices for the standard article block loop: LCP image, float insets, ads.
 */
export function useArticleBlockLoop(
  blocks: ReadonlyArray<MinimalBlock> | null | undefined,
  { paragraphRunLength }: Options,
) {
  const firstImageBlockIndex = useMemo(
    () => blocks?.findIndex((b) => b.__typename === "CoreImageBlockType") ?? -1,
    [blocks],
  );

  const adInsertAfter = useMemo(
    () => computeAdInsertionIndices(blocks ?? [], paragraphRunLength),
    [blocks, paragraphRunLength],
  );

  const insetOrderByIndex = useMemo(() => {
    const order = new Map<number, number>();
    let count = 0;
    blocks?.forEach((block, index) => {
      if (
        block.__typename === "CoreImageBlockType" &&
        block.placement === "left"
      ) {
        order.set(index, count);
        count += 1;
      }
    });
    return order;
  }, [blocks]);

  return { firstImageBlockIndex, adInsertAfter, insetOrderByIndex };
}
